module.exports = __webpack_public_path__ + "static/media/clicktostart.f4681ae2.mp3";